function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 10,
  fill: "#333"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.22 5.72a.75.75 0 011.061 1.06L11.061 10l3.22 3.22a.75.75 0 11-1.06 1.061L10 11.061l-3.22 3.22a.75.75 0 01-1.061-1.06L8.94 10 5.72 6.78a.75.75 0 011.06-1.06L10 8.94l3.22-3.22z",
  fill: "#fff"
});

function SvgCircleCancelFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMTAiIGZpbGw9IiMzMzMzMzMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy4yMjA4IDUuNzE5MThDMTMuNTEzNyA1LjQyNjI5IDEzLjk4ODYgNS40MjYyOSAxNC4yODE1IDUuNzE5MThDMTQuNTc0MyA2LjAxMjA3IDE0LjU3NDMgNi40ODY5NCAxNC4yODE1IDYuNzc5ODRMMTEuMDYxMyAxMC4wMDAxTDE0LjI4MTUgMTMuMjIwNEMxNC41NzQ0IDEzLjUxMzMgMTQuNTc0NCAxMy45ODgxIDE0LjI4MTUgMTQuMjgxQzEzLjk4ODYgMTQuNTczOSAxMy41MTM4IDE0LjU3MzkgMTMuMjIwOSAxNC4yODFMMTAuMDAwNiAxMS4wNjA3TDYuNzgwMzMgMTQuMjgxQzYuNDg3NDQgMTQuNTczOSA2LjAxMjU3IDE0LjU3MzkgNS43MTk2NyAxNC4yODFDNS40MjY3OCAxMy45ODgxIDUuNDI2NzggMTMuNTEzMyA1LjcxOTY3IDEzLjIyMDRMOC45Mzk5NSAxMC4wMDAxTDUuNzE5NzUgNi43Nzk4NEM1LjQyNjg2IDYuNDg2OTQgNS40MjY4NiA2LjAxMjA3IDUuNzE5NzYgNS43MTkxOEM2LjAxMjY1IDUuNDI2MjkgNi40ODc1MyA1LjQyNjI5IDYuNzgwNDIgNS43MTkxOEwxMC4wMDA2IDguOTM5NEwxMy4yMjA4IDUuNzE5MThaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgCircleCancelFill as ReactComponent };